module.exports = __webpack_public_path__ + "static/media/logo.25fd923a.png";